import { render, staticRenderFns } from "./seeDetails.vue?vue&type=template&id=606c1b5c&scoped=true"
import script from "./seeDetails.vue?vue&type=script&lang=js"
export * from "./seeDetails.vue?vue&type=script&lang=js"
import style0 from "./seeDetails.vue?vue&type=style&index=0&id=606c1b5c&prod&lang=scss&scoped=true"
import style1 from "./seeDetails.vue?vue&type=style&index=1&id=606c1b5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c1b5c",
  null
  
)

export default component.exports